import React, { useState, useEffect, useContext } from "react";
import UserProvisioningReadOnlyRow from "./UserProvisioningReadOnlyRow";
import UserProvisioningTableRow from "./UserProvisioningTableRow";
import { useTranslation } from 'react-i18next';
import UserContext from "../contexts/UserContext";
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function UserProvisioningTable({ key, setProvisioning, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isProvLoading, setIsProvLoading] = useState(false);
	const [userProvisionings, setUserProvisionings] = useState([]);
	const [count, setCount] = useState(key);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	useEffect(() => {
		fetchUserProvisionings();
	}, []);

	const handleClose = (event) => {
		setProvisioning(false);
	};

	function fetchUserProvisionings() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsProvLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserProvisionings", "/Service/UserService/GetUserProvisionings", requestOptions, retrieveUserProvSuccess, retrieveUserProvFail);
		} catch (error) {
			setIsProvLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserProvFail(redirect) {
		setIsProvLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.provNotRetrieved"));
	}

	function retrieveUserProvSuccess(responseData) {
		let fetchUserProvisioningsResponse;
		if (responseData) {
			fetchUserProvisioningsResponse = responseData.fetchUserProvisioningsResponse;
			if (fetchUserProvisioningsResponse && fetchUserProvisioningsResponse.errorCode === "0") {
				if (fetchUserProvisioningsResponse.provisionings) {
					setUserProvisionings(fetchUserProvisioningsResponse.provisionings);
				}
			} else if (fetchUserProvisioningsResponse && fetchUserProvisioningsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserProvisioningsResponse) {
				setError(t("error.error") + " " + fetchUserProvisioningsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsProvLoading(false);
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		saveUserProvisionings(action, setValues, completeCallback);
	};
	const saveUserProvisionings = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			provisionedAttribute: setValues.provisionedAttribute,
			flagValue: setValues.flagValue,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserProvisionings", "/Service/UserService/AddUpdateUserProvisionings", requestOptions, saveUserProvSuccess, saveUserProvFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveUserProvFail(redirect, completeCallback) {
		setError(t("error.userProvEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveUserProvSuccess(responseData, completeCallback) {
		let addUpdateUserProvisioningsResponse;
		if (responseData) {
			addUpdateUserProvisioningsResponse = responseData.addUpdateUserProvisioningsResponse;
			if (addUpdateUserProvisioningsResponse) {
				if (addUpdateUserProvisioningsResponse.errorCode === "0") {
					resetRowTable();
					fetchUserProvisionings();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserProvisioningsResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isProvLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.provisioned.attribute")}</th>
										<th className="list-th">{t("page.provisioned.value")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserProvisioningTableRow
											key={count}
											userProvisionings={userProvisionings}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userProvisionings.length % 2) > 0) ? true : false}
										/>
									}
									{(userProvisionings.length > 0) ? (
										userProvisionings.map((userProvisionedItem, index) => (
											<UserProvisioningReadOnlyRow
												key={count}
												t={t}
												userProvisionedItem={userProvisionedItem}
												handleSubmit={handleSubmit}
												oddIdx={((index % 2) > 0) ? true : false}
												setAdd={setAdd}
												setError={setError}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserProvisioningTableRow
											key={count}
											userProvisionings={userProvisionings}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userProvisionings.length % 2) > 0) ? true : false}
										/>
									}
								</tbody>
								{(userProvisionings.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.provisioned.attribute")}</th>
										<th className="list-th">{t("page.provisioned.value")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-user-loc-close"
									id="edit-user-loc-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserProvisioningTable;